<footer class="container-fluid dark-gray-bg f-white pt-3 ">
  <section class="px-0">
    <div class="d-flex flex-column flex-md-row flex-md-wrap fs-normal justify-content-between">
      <div class="px-1">
        <div>
          <h6 class="fw-bold" (click)="toggle.seekerAll = !toggle.seekerAll">
            <i class="fa " *ngIf="Utility.mobile" [class.fa-angle-down]="!toggle.seekerAll"
              [class.fa-angle-up]="toggle.seekerAll"></i>
            کارپیشه
          </h6>
          <div class="pr-4 pr-md-0 seeker-all" [class.d-none]="Utility.mobile && !toggle.seekerAll">
            <a class="d-block" routerLink="/job">جستجوی استخدام و فرصت‌های شغلی</a>
            <a class="d-block" routerLink="/job-list/company">استخدام شرکت‌های معتبر</a>
            <!-- <a class="d-block" routerLink="/company">فرصت‌های شغلی شرکت‌های معتبر</a> -->
            <a class="d-block" routerLink="/remote">کار در منزل</a>
            <a class="d-block" routerLink="/register">ثبت رزومه</a>
            <a class="d-block" routerLink="/seeker/matching">اشتراک کارجوی پیشتاز</a>
            <!-- <a class="d-block" routerLink="/services">خدمات کارپیشه</a> -->
            <a class="d-block" routerLink="/browse">عناوین شغلی</a>
            <a class="d-block" href="https://blog.karpishe.com/" target="_blank">بلاگ کارپیشه</a>
            <a class="d-block" routerLink="/hire">ثبت آگهی استخدام</a>
            <!-- <a class="d-block" routerLink="/resources">منابع ارتقای شغلی</a> -->
            <a class="d-block" routerLink="/about">درباره ما</a>
            <!-- <a class="d-block" routerLink="/employer/seekers">جستجوی رزومه‌ها</a> -->
          </div>
        </div>
      </div>
      <div class="px-1">
        <h6 class="fw-bold" (click)="toggle.capitalsAll = !toggle.capitalsAll">
          <i class="fa " *ngIf="Utility.mobile" [class.fa-angle-down]="!toggle.capitalsAll"
            [class.fa-angle-up]="toggle.capitalsAll"></i>
          استخدام مرکز استان‌ها
        </h6>
        <div class="pr-4 pr-md-0 capitals-all" [class.d-none]="Utility.mobile && !toggle.capitalsAll">
          <a class="d-block" [routerLink]="['/job-list']"> استخدام کل کشور به تفکیک شهرها</a>
          <a class="d-block" [routerLink]="['/job', {l: 'تهران،تهران' }]"> استخدام تهران</a>
          <a class="d-block" [routerLink]="['/job', {l: 'مرکزی،اراک' }]"> استخدام اراک</a>
          <a class="d-block" [routerLink]="['/job', {l: 'اردبیل،اردبیل' }]"> استخدام اردبیل</a>
          <a class="d-block" [routerLink]="['/job', {l: 'آذربایجان غربی،ارومیه' }]"> استخدام ارومیه</a>
          <a class="d-block" [routerLink]="['/job', {l: 'اصفهان،اصفهان' }]"> استخدام اصفهان</a>
          <div *ngIf="!Utility.mobile" class="rounded-xl border border-dark-gray px-2 d-inline-block pointer"
            data-toggle="collapse" data-target=".capitals-more" (click)="toggle.capitals = !toggle.capitals">
            <i class="fa fa-angle-down" [class.fa-angle-down]="!toggle.capitals"
              [class.fa-angle-up]="toggle.capitals"></i>
            نمایش همه
          </div>
          <div class="capitals-more " [class.collapse]="!Utility.mobile">
            <a class="d-block" [routerLink]="['/job', {l: 'خوزستان،اهواز' }]"> استخدام اهواز</a>
            <a class="d-block" [routerLink]="['/job', {l: 'ایلام،ایلام' }]"> استخدام ایلام</a>
            <a class="d-block" [routerLink]="['/job', {l: 'خراسان شمالی،بجنورد' }]"> استخدام بجنورد</a>
            <a class="d-block" [routerLink]="['/job', {l: 'هرمزگان،بندرعباس' }]"> استخدام بندرعباس</a>
            <a class="d-block" [routerLink]="['/job', {l: 'بوشهر،بوشهر' }]"> استخدام بوشهر</a>
            <a class="d-block" [routerLink]="['/job', {l: 'خراسان جنوبی،بیرجند' }]"> استخدام بیرجند</a>
            <a class="d-block" [routerLink]="['/job', {l: 'آذربایجان شرقی،تبریز' }]"> استخدام تبریز</a>
            <a class="d-block" [routerLink]="['/job', {l: 'لرستان،خرم آباد' }]"> استخدام خرم آباد</a>
            <a class="d-block" [routerLink]="['/job', {l: 'گیلان،رشت' }]"> استخدام رشت</a>
            <a class="d-block" [routerLink]="['/job', {l: 'سیستان و بلوچستان،زاهدان' }]"> استخدام زاهدان</a>
            <a class="d-block" [routerLink]="['/job', {l: 'زنجان،زنجان' }]"> استخدام زنجان</a>
            <a class="d-block" [routerLink]="['/job', {l: 'مازندران،ساری' }]"> استخدام ساری</a>
            <a class="d-block" [routerLink]="['/job', {l: 'سمنان،سمنان' }]"> استخدام سمنان</a>
            <a class="d-block" [routerLink]="['/job', {l: 'کردستان،سنندج' }]"> استخدام سنندج</a>
            <a class="d-block" [routerLink]="['/job', {l: 'چهارمحال و بختیاری،شهرکرد' }]"> استخدام شهرکرد</a>
            <a class="d-block" [routerLink]="['/job', {l: 'فارس،شیراز' }]"> استخدام شیراز</a>
            <a class="d-block" [routerLink]="['/job', {l: 'قزوین،قزوین' }]"> استخدام قزوین</a>
            <a class="d-block" [routerLink]="['/job', {l: 'قم،قم' }]"> استخدام قم</a>
            <a class="d-block" [routerLink]="['/job', {l: 'خراسان رضوی،مشهد' }]"> استخدام مشهد</a>
            <a class="d-block" [routerLink]="['/job', {l: 'همدان،همدان' }]"> استخدام همدان</a>
            <a class="d-block" [routerLink]="['/job', {l: 'البرز،کرج' }]"> استخدام کرج</a>
            <a class="d-block" [routerLink]="['/job', {l: 'کرمان،کرمان' }]"> استخدام کرمان</a>
            <a class="d-block" [routerLink]="['/job', {l: 'کرمانشاه،کرمانشاه' }]"> استخدام کرمانشاه</a>
            <a class="d-block" [routerLink]="['/job', {l: 'گلستان،گرگان' }]"> استخدام گرگان</a>
            <a class="d-block" [routerLink]="['/job', {l: 'کهگیلویه و بویراحمد،یاسوج' }]"> استخدام یاسوج</a>
            <a class="d-block" [routerLink]="['/job', {l: 'یزد،یزد' }]"> استخدام یزد</a>
          </div>
        </div>
      </div>
      <div class="px-1">
        <h6 class="fw-bold" (click)="toggle.favJobsAll = !toggle.favJobsAll">
          <i class="fa " *ngIf="Utility.mobile" [class.fa-angle-down]="!toggle.favJobsAll"
            [class.fa-angle-up]="toggle.favJobsAll"></i>
          فرصت‌های شغلی پرطرفدار
        </h6>
        <div class="pr-4 pr-md-0 fav-jobs-all" [class.d-none]="Utility.mobile && !toggle.favJobsAll">
          <a class="d-block" [routerLink]="['/browse']"> استخدام کل کشور به تفکیک عنوان شغل</a>
          <a class="d-block" [routerLink]="['/job', {q: 'حسابدار'}]">استخدام حسابدار</a>
          <a class="d-block" [routerLink]="['/job', {q: 'برنامه نویس'}]">استخدام برنامه نویس</a>
          <a class="d-block" [routerLink]="['/job', {q: 'کارگر ساده'}]">استخدام کارگر ساده</a>
          <a class="d-block" [routerLink]="['/job', {q: 'کارشناس فروش'}]">استخدام کارشناس فروش</a>
          <a class="d-block" [routerLink]="['/job', {q: 'راننده'}]">استخدام راننده</a>
          <a class="d-block" [routerLink]="['/job', {q: 'منشی'}]">استخدام منشی</a>
          <div *ngIf="!Utility.mobile" class="rounded-xl border border-dark-gray px-2 d-inline-block pointer"
            data-toggle="collapse" data-target=".fav-jobs-more" (click)="toggle.favJobs = !toggle.favJobs">
            <i class="fa " [class.fa-angle-down]="!toggle.favJobs" [class.fa-angle-up]="toggle.favJobs"></i>
            نمایش همه
          </div>
          <div class="fav-jobs-more" [class.collapse]="!Utility.mobile">
            <a class="d-block" [routerLink]="['/job', {q: 'کارمند اداری'}]">استخدام کارمند اداری</a>
            <a class="d-block" [routerLink]="['/job', {q: 'پیک موتوری'}]">استخدام پیک موتوری</a>
            <a class="d-block" [routerLink]="['/job', {q: 'طراح وب'}]">استخدام طراح وب</a>
            <a class="d-block" [routerLink]="['/job', {q: 'بازاریاب'}]">استخدام بازاریاب</a>
            <a class="d-block" [routerLink]="['/job', {q: 'فروشنده'}]">استخدام فروشنده</a>
            <a class="d-block" [routerLink]="['/job', {q: 'انباردار'}]">استخدام انباردار</a>
            <a class="d-block" [routerLink]="['/job', {q: 'مدیر بازاریابی'}]">استخدام مدیر بازاریابی</a>
            <a class="d-block" [routerLink]="['/job', {q: 'مدیر مالی'}]">استخدام مدیر مالی</a>
            <a class="d-block" [routerLink]="['/job', {q: 'کارمند بانک'}]">استخدام کارمند بانک</a>
            <a class="d-block" [routerLink]="['/job', {q: 'مدیر فنی'}]">استخدام مدیر فنی</a>
          </div>
        </div>
      </div>
      <div class="px-1">
        <h6 class="fw-bold" (click)="toggle.resourcesAll = !toggle.resourcesAll">
          <i class="fa " *ngIf="Utility.mobile" [class.fa-angle-down]="!toggle.resourcesAll"
            [class.fa-angle-up]="toggle.resourcesAll"></i>
          منابع ارتقای شغلی
        </h6>
        <div class="pr-4 pr-md-0 resource-all" [class.d-none]="Utility.mobile && !toggle.resourcesAll">
          <a class="d-block" [routerLink]="['/resource', type]"
            *ngFor="let type of resourceTypes | slice : 0 : 7 ">{{type|readable:'resourceType'}}</a>
          <div *ngIf="!Utility.mobile && resourceTypes?.length > 7"
            class="rounded-xl border border-dark-gray px-2 d-inline-block pointer" data-toggle="collapse"
            data-target=".resource-more" (click)="toggle.resource = !toggle.resource">
            <i class="fa " [class.fa-angle-down]="!toggle.resource" [class.fa-angle-up]="toggle.resource"></i>
            نمایش همه
          </div>
          <div class="resource-more" [class.collapse]="!Utility.mobile">
            <a class="d-block" [routerLink]="['/resource',type]"
              *ngFor="let type of resourceTypes | slice : 7 ">{{type|readable:'resourceType'}}</a>
          </div>
        </div>
      </div>
      <div class="px-1">
        <h6 class="fw-bold" (click)="toggle.remoteAll = !toggle.remoteAll">
          <i class="fa " *ngIf="Utility.mobile" [class.fa-angle-down]="!toggle.remoteAll"
            [class.fa-angle-up]="toggle.remoteAll"></i>
          دورکاری و کار در منزل
        </h6>
        <div class="pr-4 pr-md-0 remote-all" [class.d-none]="Utility.mobile && !toggle.remoteAll">
          <a class="d-block" [routerLink]="['/remote',jobtitle.Title]"
            *ngFor="let jobtitle of remoteJobtitles | slice : 0 : 7 ">{{jobtitle.DisplayTitle}}</a>
          <div *ngIf="!Utility.mobile && remoteJobtitles?.length > 7"
            class="rounded-xl border border-dark-gray px-2 d-inline-block pointer" data-toggle="collapse"
            data-target=".remote-more" (click)="toggle.remote = !toggle.remote">
            <i class="fa " [class.fa-angle-down]="!toggle.remote" [class.fa-angle-up]="toggle.remote"></i>
            نمایش همه
          </div>
          <div class="remote-more" [class.collapse]="!Utility.mobile">
            <a class="d-block" [routerLink]="['/remote',jobtitle.Title]"
              *ngFor="let jobtitle of remoteJobtitles | slice : 7 ">{{jobtitle.DisplayTitle}}</a>
          </div>
        </div>
      </div>
      <div class="px-1">
        <h6 class="fw-bold" (click)="toggle.discussionAll = !toggle.discussionAll">
          <i class="fa " *ngIf="Utility.mobile" [class.fa-angle-down]="!toggle.discussionAll"
            [class.fa-angle-up]="toggle.discussionAll"></i>
          تبادل نظر
        </h6>
        <div class="pr-4 pr-md-0 discussion-all" [class.d-none]="Utility.mobile && !toggle.discussionAll">
          <a class="d-block" [routerLink]="['/discussion',discussion.Id]"
            *ngFor="let discussion of bestDiscussions | slice : 0 : 7 ">{{discussion.Title}}</a>
          <div *ngIf="!Utility.mobile && bestDiscussions?.length > 7"
            class="rounded-xl border border-dark-gray px-2 d-inline-block pointer" data-toggle="collapse"
            data-target=".discussion-more" (click)="toggle.discussion = !toggle.discussion">
            <i class="fa " [class.fa-angle-down]="!toggle.discussion" [class.fa-angle-up]="toggle.discussion"></i>
            نمایش همه
          </div>
          <div class="discussion-more" [class.collapse]="!Utility.mobile">
            <a class="d-block" [routerLink]="['/discussion',discussion.Id]"
              *ngFor="let discussion of bestDiscussions | slice : 7 ">{{discussion.Title}}</a>
          </div>
        </div>
      </div>
      <div class="px-1">
        <h6 class="fw-bold" (click)="toggle.sourceAll = !toggle.sourceAll">
          <i class="fa " *ngIf="Utility.mobile" [class.fa-angle-down]="!toggle.sourceAll"
            [class.fa-angle-up]="toggle.sourceAll"></i>
          منابع آگهی استخدام
        </h6>
        <div class="pr-4 pr-md-0 source-all" [class.d-none]="Utility.mobile && !toggle.sourceAll">
          <a class="d-block" [routerLink]="['/job']" [queryParams]="{src:source.Title}"
            *ngFor="let source of sources | slice : 0 : 7 ">{{source.Title}}</a>
          <div *ngIf="!Utility.mobile && sources?.length > 7"
            class="rounded-xl border border-dark-gray px-2 d-inline-block pointer" data-toggle="collapse"
            data-target=".source-more" (click)="toggle.source = !toggle.source">
            <i class="fa " [class.fa-angle-down]="!toggle.source" [class.fa-angle-up]="toggle.source"></i>
            نمایش همه
          </div>
          <div class="source-more" [class.collapse]="!Utility.mobile">
            <a class="d-block" [routerLink]="['/job']" [queryParams]="{src:source.Title}"
              *ngFor="let source of sources | slice : 7 ">{{source.Title}}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="py-2">
      <div class="border-top border-white d-md-flex text-center justify-content-between fs-normal ">
        <div class="flex-md-column d-flex justify-content-between">
          <a class="fs-sm f-hover-yellow" routerLink="/terms" title="توافق‌نامه کاربری کارپیشه">توافق‌نامه کاربری</a>
          <a class="fs-sm f-hover-yellow" routerLink="/discussion/feedback">صندوقچه‌ی پیشنهاد و انتقاد</a>
        </div>
        <app-enamad style="zoom: 0.5;-moz-transform: scale(0.5);" [enamad]="true" [samandehi]="false"></app-enamad>
        <div class="flex-md-column d-flex justify-content-between text-center w-100 w-md-initial">
          <div class="d-flex justify-content-between">
            <a class="f-hover-yellow mx-1" title="لینکداین کارپیشه" href="https://www.linkedin.com/company/karpishe"
              target="_blank"><i class="fab fa-linkedin text fs-xxl"></i></a>
            <a class="f-hover-yellow mx-1" title="تویتر کارپیشه" href="https://twitter.com/karpisheco"
              target="_blank"><i class="fab fa-twitter text fs-xxl"></i></a>
            <a class="f-hover-yellow mx-1" title="کانال تلگرام کارپیشه" href="https://t.me/estekhtam_channel"
              target="_blank"><i class="fab fa-telegram-plane text fs-xxl"></i></a>
            <a class="f-hover-yellow mx-1" title="اینستاگرام کارپیشه" href="https://www.instagram.com/karpisheh/"
              target="_blank"><i class="fab fa-instagram text fs-xxl"></i></a>
          </div>
          <a class="f-hover-yellow" title="راه‌های تماس با کارپیشه" routerLink="/contact-us" target="_blank">تماس با
            کارپیشه</a>
        </div>
      </div>
    </div>
  </section>
</footer>